module.exports = __webpack_public_path__ + "img/1.b469c853.png";